import { Scene as BaseScene } from 'phaser';
import { Request } from './request';
import { Relay } from './relay';
import store from '@fg/base/store';
import { CustomHelpers } from '@fg/base/phaser_utilities/custom_helpers';

export class Scene extends BaseScene {
    constructor() {
        super();
        this.orientation = undefined;
        this.device = 'desktop';
        this.gameHeight = 768;
        this.yCenterPoint = 384;
        this.request = new Request(this);
        this.relay = new Relay(this);
    }

    init() {
        this.customHelper = new CustomHelpers({
            'scene': this
        });

        this.game.sound.pauseOnBlur = false;

        if (!this.sys.game.device.os.desktop) {
            this.checkIfOrientationChanged();
            this.device = 'mobile';
            this.toggleMute(false);
            store.commit('toggleMute');
            this.setVolume(0);
            store.commit('setVolume', 0);
            document.getElementById("fg-container").classList.add('mobile');
        } else {
            this.setVolume(store.state.volume);
        }
        
        store.commit('setDevice', this.device);

        this.scale.on('resize', this.resize, this);

        if(this.game.input.touch) {
            this.game.input.touch.capture = false;
        }
        
        document.getElementById('fg-container').classList.add('loaded'); 
        document.getElementById('fg-container').classList.remove('loading'); 
        
        var loaderContainer = document.getElementsByClassName('loader-container')[0]; 

        if(loaderContainer) {
            loaderContainer.remove();
        }

        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                this.game.sound.pauseAll();
            } else {
                this.game.sound.resumeAll();
            }
        });
    }

    resize() {
        this.checkIfOrientationChanged();
    }

    update() {
        if(this.fg) {
            this.fg.update();
        }
    }

    letInitialize(initCallback) {
        initCallback();
        if (Config.unfinishedGame) {
            this.request.loadWaitingTicket(Config.unfinishedGame);
        }
    }

    beforePurchase() {
        console.log('beforePurchase')
    }

    afterPurchase() {
        console.log('afterPurchase')
    }

    afterStep() {
        console.log('afterStep')
    }

    toggleMute(mute) {
        this.sound.setMute(mute);
    }

    setVolume(volume) {
        this.sound.setVolume(volume);

        if(!volume) {
            store.commit('muteOn');
        } else {
            store.commit('muteOff');
        }
    }

    clickEvent(clickEvent) {
        if(typeof this.customClickEvent === 'function') {
            this.customClickEvent(clickEvent);
        }
    }

    canvasReady() {
        store.commit('canvasReady');
    }
    
    currentDeviceOrientationIsPortrait() {
        return Config.windowHeight > Config.windowWidth;
    }

    checkIfOrientationChanged() {
        const currentOrientation = this.currentDeviceOrientationIsPortrait() ? 'portrait' : 'landscape';

        if(!this.sys.game.device.os.desktop && currentOrientation !== this.orientation) {
            this.orientation = currentOrientation;
            
            if(this.orientation === 'portrait') { 
               this.scale.setGameSize(Config.resolutionX_portrait, Config.resolutionY_portrait);
               this.scale.displaySize.resize(Config.resolutionX_portrait, Config.resolutionY_portrait);

               
            } else {
                this.scale.setGameSize(Config.resolutionX, Config.resolutionY);
                this.scale.displaySize.resize(Config.resolutionX, Config.resolutionY);
            }

            this.scale.refresh();

            this.baseGamePositioner();
        }
    }

    baseGamePositioner() {
        if(!this.spritesReady) {
            return;
        }

        this.positionerContainer.x = this.cameras.main.centerX;
        this.positionerContainer.y = 0;

        if(typeof this.gamePositioner === 'function') {
            this.gamePositioner();
        }
    }

    orientationIsSetToPortrait() {
        return this.orientation === 'portrait';
    }

    changeToRealModal() {
        if (Config.real_to_home) {
            window.open(Config.home_url, '_top');
            return;
        }

        store.commit('setMessage', {
            title: 'play_for_money',
            message:'buy_online',
            callback: {
                title:'play_for_money', 
                callback:() => 
                { 
                    if(Config.is_logged) {
                        Config.mode = 'real'; 
                        store.commit('changeToReal'); 
                    } else {
                        store.commit('setMessage', 
                        {
                            title: 'please_login',
                            message:'in_order_to_buy',
                            callback: {
                                title:'ok',
                                callback:() => {
                                    if (Config.login_page) {
                                        redirectLogin();
                                    } else {
                                        location.reload();
                                    }

                                    parent.postMessage({ auth: true }, '*');
                                }
                            },
                        });
                    }
                }
            },
            callback2: {title:'not_now', callback:()=>{}}
        });
    }
}